import styled from 'styled-components';

export const FaqPageStyles = styled.div`
.container-fluid {
  .header-wrap {
    grid-template-columns: repeat(3,auto);
  }
}
`

export const FaqStyles = styled.div`
padding: 0px 20px;

.header-wrap {
  grid-template-columns: repeat(3,auto);
}

.hero {
  ${props => props.theme.media.md} {
    min-height: initial;
  }
}

.faq-body {
  ${props => props.theme.media.lg} {
    display: flex;
    grid-gap: 60px;
    padding: 0 118px;
    justify-content: center;
  }
}

.faq-container {
  position: relative;
  .faq-title {
    font-size: 22px;
    letter-spacing: 0px;

    ${props => props.theme.media.sm} {
      font-size: 24px;
    }

    ${props => props.theme.media.lg} {
      font-size: 45px;
    }
  
    &::after {
      content: '';
      display: block;
      background-image: url('/icons/faq-bubbles.svg');
      background-size: 88px 110px;
      width: 88px;
      min-width: 88px;
      height: 110px;
      min-height: 110px;
      position: absolute;
      bottom: -142%;
      right: 10%;
      
      ${props => props.theme.media.sm} {
        bottom: -70%;
        right: 5%;
      }

      ${props => props.theme.media.lg} {
        background-size: 140px 150px;
        width: 140px;
        min-width: 140px;
        height: 150px;
        min-height: 150px;
        bottom: -55%;
        right: 1%;
      }
    }
  }
}

.faq {
  ${props => props.theme.media.lg} {
    width: 800px;
  }
  .Collapsible {
    padding: 10px 0;
    transition: all 0.2s;
    border-top: 1px solid #D7D6D7;
    &__trigger {
      font-weight: 700;
      display: inline-block;
      padding: 4px 0;
      cursor: pointer;
      position: relative;
      padding-right: 30px;
      width: 100%;
      &::after {
        content: '+';
        position: absolute;
        right: 0;
        top: 4px;
        color: #FF6600;
        font-size: 20px;
        font-weight: 100;
        transition: all 0.3s;
        line-height: 1;
      }
      &.is-open {
        &::after {
          transform: rotate(135deg);
        }
      }
    }
    &__contentInner {
      padding: 10px 0;
    }
  }
  
  .Collapsible__trigger {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #4B5054;
    letter-spacing: 0px;

    ${props => props.theme.media.lg} {
      font-size: 16px;
    }
  }

  .Collapsible__contentInner {
    p {
      font-size: 12px;
      font-family: Inter;
      color: #4B5054;
      line-height: #4B5054;
      letter-spacing: 0px;

      ${props => props.theme.media.lg} {
        font-size: 14px;
        width: 100%;
        max-width: 700px;
      }
    }
  }

  h2 {
    margin-top: 20px;
    scroll-margin-top: 60px;
    text-align: left;
    font-size: 20px;
    color: #4B5054;
    font-weight: 600;
    text-decoration: underline;
  }
}

.sidebar {
  ${props => props.theme.media.lg} {
    display: flex;
    flex-direction: column;
  }
}

.sticky-elements-wrapper {
  ${props => props.theme.media.lg} {
    flex: 1;
    margin-bottom: 3rem;
    position: relative;
    height: 2000px;
  }
}

.sticky-elements {
  ${props => props.theme.media.lg} {
    position: sticky;
    top: calc(56.7667px + 1rem);
  }
}
`;
